import { render, staticRenderFns } from "./stepUi.vue?vue&type=template&id=38b21b2c&scoped=true&"
import script from "./stepUi.vue?vue&type=script&lang=js&"
export * from "./stepUi.vue?vue&type=script&lang=js&"
import style0 from "./stepUi.vue?vue&type=style&index=0&id=38b21b2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b21b2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38b21b2c')) {
      api.createRecord('38b21b2c', component.options)
    } else {
      api.reload('38b21b2c', component.options)
    }
    module.hot.accept("./stepUi.vue?vue&type=template&id=38b21b2c&scoped=true&", function () {
      api.rerender('38b21b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/components/patrolTemplate/hiddenDangerRecordType/stepUi.vue"
export default component.exports